import React from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from 'components/mediaQueries';
import { MiniArticleCard as MiniArticleCardType } from 'data/global/types';
import { MiniArticleCard } from 'components/Cards/MiniArticleCard/MiniArticleCard';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { useInView } from 'react-intersection-observer';

type Props = {
  articles: MiniArticleCardType[];
  componentNameForTracking?: string;
};

export const MiniArticleCards = ({
  articles,
  componentNameForTracking,
}: Props) => {
  const trackEvent = useTrackEvent();
  const [ref, inView] = useInView();

  React.useEffect(() => {
    if (inView && componentNameForTracking) {
      trackEvent('component_scrolled_into_view', {
        component: componentNameForTracking,
      });
    }
  }, [ref, inView]);

  if (!articles.length) {
    return null;
  }

  return (
    <List ref={ref}>
      {articles.map((article: MiniArticleCardType, index: number) => {
        if (index < 5)
          return (
            <li key={index}>
              <MiniArticleCard article={article} />
            </li>
          );
      })}
    </List>
  );
};

const List = styled.ul`
  display: grid;
  grid-row-gap: 10px;
  ${mediaQueries.tablet} {
    grid-row-gap: 15px;
    min-width: 100%;
    width: 100%;
  }
  ${mediaQueries.desktop} {
    grid-template-columns: repeat(5, min-content);
    grid-column-gap: 20px;
    min-width: 100%;
    width: 1200px;
  }
`;
